const FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]'

const MARK = 'data-hidden-focus'

function sync(root) {
  root.querySelectorAll('.vhl-list:not([tabindex])').forEach(list => {
    list.setAttribute('tabindex', '0')
  })
  root.querySelectorAll(`[${MARK}]`).forEach(element => {
    if (!element.closest('[aria-hidden="true"]')) {
      element.removeAttribute('tabindex')
      element.removeAttribute(MARK)
    }
  })
  root.querySelectorAll('[aria-hidden="true"]').forEach(hidden => {
    hidden.querySelectorAll(FOCUSABLE).forEach(element => {
      if (element.getAttribute('tabindex') === '-1') return
      element.setAttribute('tabindex', '-1')
      element.setAttribute(MARK, '')
    })
  })
}

export function keepHiddenContentOutOfTabOrder(root) {
  if (!root || typeof MutationObserver === 'undefined') return null
  sync(root)
  const observer = new MutationObserver(() => sync(root))
  observer.observe(root, {
    attributes: true,
    attributeFilter: ['aria-hidden', 'tabindex'],
    childList: true,
    subtree: true,
  })
  return observer
}
